import {
  Box,
  Checkbox,
  FormControl,
  FormControlLabel,
  IconButton,
  InputAdornment,
  InputLabel,
  OutlinedInput,
  Select,
  Typography,
} from "@material-ui/core";
import React, { useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import HomeIcon from "@material-ui/icons/Home";
import AddIcon from "@material-ui/icons/Add";
import SearchIcon from "@material-ui/icons/Search";
import DeleteIcon from "@material-ui/icons/Delete";
import axios from "axios";

const useStyles = makeStyles({
  quoteHeading: {
    display: "flex",
    justifyContent: "space-between",
    background: "#DEECFC",
    padding: "10px 20px",
    borderRadius: "10px",
    margin: "10px 0",
  },
  quoteContent: {
    padding: "10px 0px",
    borderRadius: "5px",
  },
  title: {
    paddingBottom: "0px",
  },
  requestQuoteTitle: {
    display: "flex",
    alignItems: "center",
    columnGap: "5px",
  },
  formControl: {
    minWidth: 300,
  },
  selectEmpty: {},
  quoteContainer: {
    display: "flex",
    gap: "20px",
    flexWrap: "wrap",
  },
  requestQuote1Submit: {
    width: "160px",
    height: "45px",
    marginInlineEnd: "10px",
    background: "#BE1E2D",
    color: "#fff",
    marginTop: "20px",
    fontWeight: "600",
  },
});

const ProjectDetails = ({
  handleChangePdValue,
  id,
  handleCountDataDelete,
  productDetailsValue,
}) => {
  const classes = useStyles();
  const [productDetalis, setProductDetalis] = useState();
  const [render, setRender] = useState(0);
  useEffect(() => {
    const fetchData = async () => {
      const res = await axios(
        `https://abc-backend.onrender.com/api/quotes/${id}`
      );

      setProductDetalis(
        res.data.data?.productDetailsValue.length > 0
          ? res.data.data?.productDetailsValue
          : [{ test: "test" }]
      );
    };

    fetchData();
  }, [id]);
  const hanldeIncrementDetails = () => {
    const product = productDetalis;
    product.push({ test: "test" });
    setProductDetalis(product);
    setRender(render + 1);
  };
  const handleCountDelete = (i) => {
    const filterCount = productDetalis.filter((_, index) => index !== i);
    setProductDetalis(filterCount);
    handleCountDataDelete(i);
    console.log("click");
  };
  return (
    <>
      <Box className="desktop">
        <Box
          style={{
            display: "flex",
            alignItems: "center",
            columnGap: "10px",
            padding: "15px 0",
          }}
        >
          <Typography variant="span">
            <HomeIcon />
          </Typography>
          <Typography variant="h6">Product Details </Typography>
        </Box>
        <Box className="quoteHeading2">
          <Box className="firstHeading">
            <Typography variant="h5">Product</Typography>
          </Box>
          <Box className="firstHeading2">
            <Typography variant="h5">Product Classification</Typography>
          </Box>
          <Box className="firstHeading3">
            <Typography variant="h5">Qty</Typography>
          </Box>
          <Box className="firstHeading4">
            <Typography variant="h5">Weight</Typography>
          </Box>
          <Box className="firstHeading5">
            <Typography variant="h5">Size</Typography>
          </Box>
          <Box className="firstHeading6">
            <Typography variant="h5">MSDS</Typography>
          </Box>
          <Box className="firstHeading7">
            <Typography variant="h5">Packing</Typography>
          </Box>
          <Box className="firstHeading8">
            <Typography variant="h5">Package Type</Typography>
          </Box>
          <Box className="firstHeading9">
            <Typography variant="h5">Gross Value</Typography>
          </Box>
          <Box className="firstHeading10">
            <Typography variant="span">
              <AddIcon onClick={hanldeIncrementDetails} />
            </Typography>
          </Box>
        </Box>

        <Box className="requestQuoteInputParent">
          {productDetalis &&
            productDetalis?.map((pdData, i) => (
              <>
                {i !== 0 && (
                  <button
                    onClick={() => handleCountDelete(i)}
                    className="quote_details_btn"
                  >
                    <DeleteIcon />
                  </button>
                )}
                <Box className="requestQuoteInput" key={i}>
                  <Box className="input1">
                    <FormControl
                      className={(classes.margin, classes.textField)}
                      variant="outlined"
                    >
                      <InputLabel htmlFor="outlined-adornment-password">
                        Enter commodity type
                      </InputLabel>
                      <OutlinedInput
                        id="outlined-adornment-password"
                        type="text"
                        name="product"
                        required
                        onBlur={(e) => handleChangePdValue(e, i)}
                        defaultValue={pdData.product ? pdData.product : ""}
                        endAdornment={
                          <InputAdornment position="end">
                            <IconButton
                              aria-label="toggle password visibility"
                              edge="end"
                            >
                              <SearchIcon />
                            </IconButton>
                          </InputAdornment>
                        }
                      />
                    </FormControl>
                  </Box>
                  <Box className="input2">
                    <FormControl
                      className={(classes.margin, classes.textField)}
                      variant="outlined"
                    >
                      <InputLabel htmlFor="outlined-adornment-password">
                        Chemicals
                      </InputLabel>
                      <OutlinedInput
                        type="text"
                        required
                        name="productClassification"
                        onBlur={(e) => handleChangePdValue(e, i)}
                        defaultValue={
                          pdData.productClassification
                            ? pdData.productClassification
                            : ""
                        }
                      />
                    </FormControl>
                  </Box>
                  <Box className="input3">
                    <FormControl
                      className={(classes.margin, classes.textField)}
                      variant="outlined"
                    >
                      <InputLabel htmlFor="outlined-adornment-password">
                        Qty
                      </InputLabel>
                      <OutlinedInput
                        type="number"
                        name="Qty"
                        required
                        onBlur={(e) => handleChangePdValue(e, i)}
                        defaultValue={pdData.Qty ? pdData.Qty : ""}
                      />
                    </FormControl>
                  </Box>
                  <Box className="input4">
                    <FormControl
                      className={(classes.margin, classes.textField)}
                      variant="outlined"
                    >
                      <InputLabel htmlFor="outlined-adornment-password">
                        500 kgs
                      </InputLabel>
                      <OutlinedInput
                        type="text"
                        name="weight"
                        required
                        onBlur={(e) => handleChangePdValue(e, i)}
                        defaultValue={pdData.weight ? pdData.weight : ""}
                      />
                    </FormControl>
                  </Box>
                  <Box className="input13">
                    <FormControl
                      className={(classes.margin, classes.textField)}
                      variant="outlined"
                    >
                      <InputLabel htmlFor="outlined-adornment-password">
                        500
                      </InputLabel>
                      <OutlinedInput
                        type="text"
                        name="sizeInput"
                        required
                        onBlur={(e) => handleChangePdValue(e, i)}
                        defaultValue={pdData.sizeInput ? pdData.sizeInput : ""}
                      />
                    </FormControl>
                  </Box>
                  <Box className="input8">
                    <FormControl
                      className={(classes.margin, classes.textField)}
                      variant="outlined"
                    >
                      <Select
                        native
                        required
                        onBlur={(e) => handleChangePdValue(e, i)}
                        name="sizeSelect"
                      >
                        <option
                          aria-label="None"
                          value={pdData.sizeSelect}
                          selected
                          defaultValue={
                            pdData.sizeSelect ? pdData.sizeSelect : ""
                          }
                        >
                          {pdData.sizeSelect ? pdData.sizeSelect : ""}
                        </option>
                        <option value={"INCH"}>INCH</option>
                        <option value={"CBM"}>CBM</option>
                      </Select>
                    </FormControl>
                  </Box>
                  <Box className="input9">
                    <FormControl
                      className={(classes.margin, classes.textField)}
                      variant="outlined"
                    >
                      <InputLabel htmlFor="outlined-adornment-password"></InputLabel>
                      <OutlinedInput
                        type="text"
                        required
                        name="MSDS2"
                        onBlur={(e) => handleChangePdValue(e, i)}
                        defaultValue={pdData.MSDS2 ? pdData.MSDS2 : ""}
                      />
                    </FormControl>
                  </Box>
                  <Box className="input10">
                    <FormControl
                      className={(classes.margin, classes.textField)}
                      variant="outlined"
                    >
                      <Select
                        native
                        required
                        onBlur={(e) => handleChangePdValue(e, i)}
                        name="Packing"
                      >
                        <option
                          aria-label="None"
                          value={pdData.Packing}
                          selected
                          defaultValue={pdData.Packing ? pdData.Packing : ""}
                        >
                          {pdData.Packing ? pdData.Packing : ""}
                        </option>
                        <option value={"Packed"}>Packed</option>
                      </Select>
                    </FormControl>
                  </Box>
                  <Box className="input11">
                    <FormControl
                      className={(classes.margin, classes.textField)}
                      variant="outlined"
                    >
                      <InputLabel htmlFor="outlined-adornment-password">
                        Pallets
                      </InputLabel>
                      <OutlinedInput
                        type="text"
                        name="packageType"
                        required
                        onBlur={(e) => handleChangePdValue(e, i)}
                        defaultValue={
                          pdData.packageType ? pdData.packageType : ""
                        }
                      />
                    </FormControl>
                  </Box>
                  <Box className="input12">
                    <FormControl
                      className={(classes.margin, classes.textField)}
                      variant="outlined"
                    >
                      <InputLabel htmlFor="outlined-adornment-password">
                        AED 100,000
                      </InputLabel>
                      <OutlinedInput
                        type="text"
                        name="grossValue"
                        required
                        onBlur={(e) => handleChangePdValue(e, i)}
                        defaultValue={
                          pdData.grossValue ? pdData.grossValue : ""
                        }
                      />
                    </FormControl>
                  </Box>
                  <Box className="DetailscheckBox">
                    <FormControlLabel
                      control={
                        <Checkbox
                          onBlur={(e) => handleChangePdValue(e, i)}
                          name="stackable"
                          checked={
                            productDetailsValue[productDetalis.length]
                              ?.stackable
                          }
                          defaultChecked={pdData.stackable ? true : false}
                          color="primary"
                        />
                      }
                      label="Stackable"
                    />
                  </Box>
                </Box>
              </>
            ))}
        </Box>
      </Box>
      <Box className="mobile">
        <Box className="product_details_mobile">
          <Box
            style={{
              display: "flex",
              alignItems: "center",
              columnGap: "10px",
              padding: "15px 0",
            }}
          >
            <Typography variant="span">
              <HomeIcon />
            </Typography>
            <Typography variant="h6">Product Details </Typography>
          </Box>
          {productDetalis?.map((pdData, i) => (
            <>
              <Box className="quoteHeading2" key={i}>
                <Box className="firstHeading10">
                  <Typography variant="span">
                    <AddIcon onClick={hanldeIncrementDetails} />
                  </Typography>
                </Box>
                {i !== 0 && (
                  <button
                    onClick={() => handleCountDelete(i)}
                    className="quote_details_btn"
                  >
                    <DeleteIcon />
                  </button>
                )}
                <Box className="firstHeading">
                  <Typography variant="h5">Product</Typography>
                  <Box className="input1">
                    <FormControl
                      className={(classes.margin, classes.textField)}
                      variant="outlined"
                    >
                      <InputLabel htmlFor="outlined-adornment-password">
                        Enter commodity type
                      </InputLabel>
                      <OutlinedInput
                        id="outlined-adornment-password"
                        type="text"
                        name="product"
                        required
                        onBlur={(e) => handleChangePdValue(e, i)}
                        defaultValue={pdData.product ? pdData.product : ""}
                        endAdornment={
                          <InputAdornment position="end">
                            <IconButton
                              aria-label="toggle password visibility"
                              edge="end"
                            >
                              <SearchIcon />
                            </IconButton>
                          </InputAdornment>
                        }
                      />
                    </FormControl>
                  </Box>
                </Box>
                <Box className="firstHeading2">
                  <Typography variant="h5">Product Classification</Typography>
                  <Box className="input2m">
                    <FormControl
                      className={(classes.margin, classes.textField)}
                      variant="outlined"
                    >
                      <InputLabel htmlFor="outlined-adornment-password">
                        Chemicals
                      </InputLabel>
                      <OutlinedInput
                        type="text"
                        required
                        name="productClassification"
                        onBlur={(e) => handleChangePdValue(e, i)}
                        defaultValue={
                          pdData.productClassification
                            ? pdData.productClassification
                            : ""
                        }
                      />
                    </FormControl>
                  </Box>
                </Box>
                <Box className="firstHeading3">
                  <Typography variant="h5">Qty</Typography>
                  <Box className="input3">
                    <FormControl
                      className={(classes.margin, classes.textField)}
                      variant="outlined"
                    >
                      <InputLabel htmlFor="outlined-adornment-password">
                        Qty
                      </InputLabel>
                      <OutlinedInput
                        type="number"
                        name="Qty"
                        required
                        onBlur={(e) => handleChangePdValue(e, i)}
                        defaultValue={pdData.Qty ? pdData.Qty : ""}
                      />
                    </FormControl>
                  </Box>
                </Box>
                <Box className="firstHeading4">
                  <Typography variant="h5">Weight</Typography>
                  <Box className="input4">
                    <FormControl
                      className={(classes.margin, classes.textField)}
                      variant="outlined"
                    >
                      <InputLabel htmlFor="outlined-adornment-password">
                        500 kgs
                      </InputLabel>
                      <OutlinedInput
                        type="text"
                        name="weight"
                        required
                        onBlur={(e) => handleChangePdValue(e, i)}
                        defaultValue={pdData.weight ? pdData.weight : ""}
                      />
                    </FormControl>
                  </Box>
                </Box>
                <Box className="firstHeading5">
                  <Typography variant="h5">Size</Typography>
                  <Box className="input13">
                    <FormControl
                      className={(classes.margin, classes.textField)}
                      variant="outlined"
                    >
                      <InputLabel htmlFor="outlined-adornment-password">
                        500
                      </InputLabel>
                      <OutlinedInput
                        type="text"
                        name="sizeInput"
                        required
                        onBlur={(e) => handleChangePdValue(e, i)}
                        defaultValue={pdData.sizeInput ? pdData.sizeInput : ""}
                      />
                    </FormControl>
                  </Box>
                  <Box className="input8">
                    <FormControl
                      className={(classes.margin, classes.textField)}
                      variant="outlined"
                    >
                      <Select
                        native
                        required
                        onBlur={(e) => handleChangePdValue(e, i)}
                        name="sizeSelect"
                      >
                        <option
                          aria-label="None"
                          value={pdData.sizeSelect}
                          selected
                          defaultValue={
                            pdData.sizeSelect ? pdData.sizeSelect : ""
                          }
                        >
                          {pdData.sizeSelect ? pdData.sizeSelect : ""}
                        </option>
                        <option value={"INCH"}>INCH</option>
                        <option value={"CBM"}>CBM</option>
                      </Select>
                    </FormControl>
                  </Box>
                </Box>
                <Box className="firstHeading6">
                  <Typography variant="h5">MSDS</Typography>
                  <Box className="input9">
                    <FormControl
                      className={(classes.margin, classes.textField)}
                      variant="outlined"
                    >
                      <InputLabel htmlFor="outlined-adornment-password"></InputLabel>
                      <OutlinedInput
                        type="text"
                        required
                        name="MSDS2"
                        onBlur={(e) => handleChangePdValue(e, i)}
                        defaultValue={pdData.MSDS2 ? pdData.MSDS2 : ""}
                      />
                    </FormControl>
                  </Box>
                </Box>
                <Box className="firstHeading7">
                  <Typography variant="h5">Packing</Typography>
                  <Box className="input10">
                    <FormControl variant="outlined">
                      <Select
                        native
                        required
                        onBlur={(e) => handleChangePdValue(e, i)}
                        name="Packing"
                      >
                        <option
                          aria-label="None"
                          value={pdData.Packing}
                          selected
                          defaultValue={pdData.Packing ? pdData.Packing : ""}
                        >
                          {pdData.Packing ? pdData.Packing : ""}
                        </option>
                        <option value={"Packed"}>Packed</option>
                      </Select>
                    </FormControl>
                  </Box>
                </Box>
                <Box className="firstHeading8">
                  <Typography variant="h5">Package Type</Typography>
                  <Box className="input11">
                    <FormControl variant="outlined">
                      <InputLabel htmlFor="outlined-adornment-password">
                        Pallets
                      </InputLabel>
                      <OutlinedInput
                        type="text"
                        name="packageType"
                        required
                        onBlur={(e) => handleChangePdValue(e, i)}
                        defaultValue={
                          pdData.packageType ? pdData.packageType : ""
                        }
                      />
                    </FormControl>
                  </Box>
                </Box>
                <Box className="firstHeading9">
                  <Typography variant="h5">Gross Value</Typography>
                  <Box className="input12">
                    <FormControl
                      className={(classes.margin, classes.textField)}
                      variant="outlined"
                    >
                      <InputLabel htmlFor="outlined-adornment-password">
                        AED 100,000
                      </InputLabel>
                      <OutlinedInput
                        type="text"
                        name="grossValue"
                        required
                        onBlur={(e) => handleChangePdValue(e, i)}
                        defaultValue={
                          pdData.grossValue ? pdData.grossValue : ""
                        }
                      />
                    </FormControl>
                  </Box>
                  <Box className="DetailscheckBox">
                    <FormControlLabel
                      control={
                        <Checkbox
                          onBlur={(e) => handleChangePdValue(e, i)}
                          name="stackable"
                          checked={
                            productDetailsValue[productDetalis.length]
                              ?.stackable
                          }
                          defaultChecked={pdData.stackable ? true : false}
                          color="primary"
                        />
                      }
                      label="Stackable"
                    />
                  </Box>
                </Box>
              </Box>
            </>
          ))}
        </Box>
      </Box>
    </>
  );
};

export default ProjectDetails;
